import { React, useContext } from "react";
import axios from "axios";
import styled from "styled-components";

//Context
import MyContext from "../../context/MyContext";

//Styled Components
import { Form } from "../styles/Form.styled";
import { Input } from "../styles/Input.styled";

const ButtonWrapper = styled.div`
  display: flex;
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  align-items: center;
  justify-content: center;
`;

const FormHeading = styled.div`
  text-align: center;
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: x-large;
  font-family: ${(props) => props.theme.font.legal};
`;

const FormSubHeadingCentre = styled.div`
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: large;
  text-align: center;
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default function Authentication(props) {
  const {
    dev,
    data,
    setData,
    dataFetched,
    setDataFetched,
    headers,
    idVerification,
    setIdVerification,
    idVerificationFailed,
    setIdVerificationFailed,
  } = useContext(MyContext);

  const GetLead = (idNumber) => {
    const leadData = {
      leadId: data.leadId,
      idNumber: idNumber,
    };
    if (headers && !dataFetched && data.leadId) {
      setDataFetched(true);
      axios
        .post(
          dev ? "http://localhost:5000/api/get-lead" : "api/get-lead",
          leadData,
          {
            headers: headers,
          }
        )
        .then(
          (response) => {
            if (response.status === 200) {
              console.log("Laminin Response: " + response.status);
              setIdVerification(true);
              SaveLead(response);
            } else {
              setIdVerificationFailed(true);
              console.log("Laminin Response: " + response.status);
            }
          },
          (error) => {
            setIdVerificationFailed(true);
            console.log("Laminin Response Error: " + error);
          }
        );
    }
  };

  const SaveLead = (response) => {
    setData((prevValue) => {
      return {
        ...prevValue,
        //Client
        title: response.data.Fields.Title,
        initials: response.data.Fields.Initials,
        firstName: response.data.Fields.FirstName,
        lastName: response.data.Fields.LastName,
        gender: response.data.Fields.Gender,
        dob: response.data.Fields.DateofBirth,
        idNumber: response.data.Fields.IdNumber,
        idType: response.data.Fields.IDType,
        idCountry: response.data.Fields.IDCountry,
        maritalStatus: response.data.Fields.MaritalStatus,
        mobile: response.data.Fields.MobilePhone,
        workTelNo: response.data.Fields.WorkPhone,
        homeTelNo: response.data.Fields.HomePhone,
        altTelNo: response.data.Fields.AlternativeNumber,
        email: response.data.Fields.Email,
        preferredCommunicationType:
          response.data.Fields.PreferredCommunicationType,

        //Street Address
        streetAddress: response.data.Fields.StreetAddress,
        complex: response.data.Fields.StreetAddress2,
        suburb: response.data.Fields.Suburb,
        city: response.data.Fields.City,
        province: response.data.Fields.Province,
        postalCode: response.data.Fields.PostalCode,
        country: response.data.Fields.Country,

        //Postal
        postalAddress: response.data.Fields.PostalAddress,
        postalComplex: response.data.Fields.PostalAddress2,
        postalSuburb: response.data.Fields.PostalSuburb,
        postalCity: response.data.Fields.PostalCity,
        postalProvince: response.data.Fields.PostalProvince,
        postalPostalCode: response.data.Fields.PostalPostalCode,
      };
    });
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    GetLead(data.otp);
  };

  const handleInfoChange = (event) => {
    const { name, value } = event.target;
    setData((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });
  };
  return (
    <div>
      {!idVerification && !idVerificationFailed && (
        <Form onSubmit={handleFormSubmit}>
          <FormHeading>AUTHENTICATION</FormHeading>
          <FormSubHeadingCentre>
            Please enter the client ID Number and click on Submit
          </FormSubHeadingCentre>
          <InputWrapper>
            <Input
              type="text"
              name="otp"
              onChange={handleInfoChange}
              onWheel={(e) => e.target.blur()}
              placeholder=""
              required={true}
              value={data.otp}
              width="140px"
              modwidth="140px"
              maxLength={13}
            />
          </InputWrapper>
          <ButtonWrapper>
            <button
              className="btn btn-dark btn-md"
              type="submit"
              style={{ margin: "0 2px" }}
            >
              Submit
            </button>
          </ButtonWrapper>
        </Form>
      )}

      {idVerificationFailed && (
        <Form>
          <FormHeading>AUTHENTICATION FAILED</FormHeading>
          <FormSubHeadingCentre>
            Could not validate your ID number. We apologise for the
            inconvenience. Please contact us on {props.phone}.
          </FormSubHeadingCentre>
        </Form>
      )}
    </div>
  );
}
